import { render, staticRenderFns } from "./TrillAccountModule.vue?vue&type=template&id=06e51b9a&scoped=true"
import script from "./TrillAccountModule.vue?vue&type=script&lang=js"
export * from "./TrillAccountModule.vue?vue&type=script&lang=js"
import style0 from "./TrillAccountModule.vue?vue&type=style&index=0&id=06e51b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e51b9a",
  null
  
)

export default component.exports